import { render, staticRenderFns } from "./ResourcesUsagePage.vue?vue&type=template&id=7f57c5ba&"
import script from "./ResourcesUsagePage.vue?vue&type=script&lang=ts&"
export * from "./ResourcesUsagePage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports